import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useTranslation } from 'react-i18next';

interface stateProps {
    key: string;
    name: string;
}

interface ConfigurationComponentProps{
    componentID: string;
    index: number;
    inputs: InputProps;
    handleDrag: (fieldID: string) => void;
    handleChange: (name:string, value:string, index:number) => void;
};

export interface InputProps{
    fieldName: string;
    dropdownSelectAI: string;
    requestForAI?: string; //if selectAI is true
    fieldToConnect?: string;//else
};
export const ConfigurationComponent =({
    index,
    inputs,
    handleDrag,
    handleChange
}:ConfigurationComponentProps)=>{
    const { t } = useTranslation('toolsApps');
    const stateList: stateProps[] = [
        {
            key: 'With AI',
            name: t('ocr.stateWithAI')
        },
        {
            key: 'With Configuration',
            name: t('ocr.stateWithoutKI')
        }
    ]
    return(
        <div className="border border-secondary border-1 rounded m-2 p-2">
            <div className="row">
                <div className='mt-1 input-group'>
                    <label className='input-group-text p-1'>{t('ocr.name')}</label>
                    <input
                    type='text'
                    className='form-control rounded-end p-1'
                    name='fieldName'
                    value={inputs.fieldName}
                    placeholder={t('ocr.name')}
                    onChange={e => handleChange(e.target.name,e.target.value,index)}
                    />
                </div>
            </div>
            <div className="row">
                <div className='mt-1 input-group'>
                    <select 
                        className="form-select"
                        name="dropdownSelectAI"
                        onChange={e => handleChange('dropdownSelectAI',e.target.value,index)}
                    >
                        {stateList.map(option=>(
                            <option 
                                selected={option.key===inputs.dropdownSelectAI}
                                value={option.key}
                            >{option.name}
                            </option>
                        ))}
                    </select>
                </div>
                
            </div>
            <div className="row mt-1">
                {
                    inputs.dropdownSelectAI === 'With AI'
                    ?   <>
                            <div className="fw-bold fs-6">
                                {t('ocr.aiSettings')}
                            </div>
                            <div className='input-group'>
                                <input
                                    type="text"
                                    className="form-control"
                                    name='requestForAI'
                                    value={inputs.requestForAI ?? ''}
                                    placeholder={t('ocr.aiSettingsDescription')}
                                    onChange={e => handleChange(e.target.name,e.target.value,index)}
                                />
                            </div>
                        </>
                    :   <>
                            <div className="fw-bold fs-6">
                                {t('ocr.configurationSettings')}
                            </div>
                            <div className="row p-1 m-0">
                                <div className="col">
                                    <div className="drop-container mb-2 p-1"
                                        title="connect fields here"
                                        data-bs-toggle='tooptip'
                                    >
                                        <FontAwesomeIcon
                                        className="me-2"
                                            icon={faPlus}
                                        />
                                        {inputs.fieldToConnect ??  t('ocr.connectionPointDescription')}
                                    </div>
                                </div>
                            </div>
                            <div className="row p-0 m-0">
                                <div className="col">
                                    <button 
                                        className="btn btn-light p-1"
                                        onClick={() => console.log('function not implemented')}
                                    >
                                        {t('ocr.autoAnalyzeConnectedFields')}
                                    </button>
                                </div>
                                <div className="col text-end">
                                    <button 
                                        className="btn btn-light p-1"
                                        data-bs-toggle="modal"
                                        data-bs-target={'#configurationModal_blockInput_'+String(index)}
                                        onClick={ e => ($('#configurationModal_blockInput_'+String(index)).appendTo('body'))}
                                    >
                                    {t('ocr.showConfig')}
                                    </button>
                                </div>
                            </div>
                            
                        </>
                }
            </div>
            
        </div>
    )
};
